import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Link from 'shared/components/Link/Link';
import withDialogs from 'shared/hocs/withDialogs';
import { withTranslate } from 'shared/hocs/withTranslate';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './DialogForm.css';

const isMobile = __APP__ === 'mobile';

class DialogForm extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    classForScroll: PropTypes.string.isRequired,
    customStyle: PropTypes.string.isRequired,
    user: PropTypes.shape().isRequired,
    verifiedPhone: PropTypes.shape(),
    children: PropTypes.node,
    //
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    classForScroll: '',
    customStyle: '',
    verifiedPhone: null,
    children: null,
  };

  state = {
    textareaMsg: '',
  };

  onEnterPress = e => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      this.submitForm();
    }
  };

  submitForm = () => {
    const { onSubmit } = this.props;
    const { textareaMsg } = this.state;

    if (textareaMsg) {
      this.setState({ textareaMsg: '' });
      onSubmit(textareaMsg);
    }
  };

  render() {
    const { t, classForScroll, verifiedPhone, customStyle, user: { token }, children } = this.props;
    const { textareaMsg } = this.state;
    const disabled = !textareaMsg || !verifiedPhone;
    const rootClass = isMobile ? s.rootMobile : s.root;
    return (
      <form className={cx(rootClass, customStyle)}>
        <textarea
          placeholder={t('Напишите сообщение...')}
          className={s.textareaMsg}
          value={textareaMsg}
          onChange={e => this.setState({ textareaMsg: e.target.value })}
          onKeyDown={disabled ? () => {} : this.onEnterPress}
        />
        <div className={s.infoBlock}>
          <div>
            {!verifiedPhone &&
              !!token &&
              <div className={s.verifyInfoMsg}>
                {t('Для активации сообщений, нужно')}{' '}
                <Link to={'/profile/'}>{t('указать и подтвердить')}</Link> {t('номер телефона')}
              </div>}
            {!token &&
              <div className={s.verifyInfoMsg}>
                {t('Для активации сообщений, нужно')}{' '}
                <Link to={'/login/'}>{t('авторизоваться')}</Link>
              </div>}
            {children}
          </div>
          <button
            className={`${s.btnSend} ${classForScroll} ${disabled ? s.disabledBtn : ''}`}
            onClick={this.submitForm}
            disabled={disabled}
            data-lens-event="contactSellerClick"
          >
            {t('Отправить')}
          </button>
        </div>
      </form>
    );
  }
}

export default withStyles(s)(withTranslate(withDialogs(DialogForm)));



// WEBPACK FOOTER //
// ./src/shared/components/DialogForm/DialogForm.js